import { render } from "./Loading.vue?vue&type=template&id=7563d59c&scoped=true"
import script from "./Loading.vue?vue&type=script&lang=ts"
export * from "./Loading.vue?vue&type=script&lang=ts"

import "./Loading.vue?vue&type=style&index=0&id=7563d59c&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-7563d59c"

export default script